import { TariffApiRoutes } from "../api";
export class TariffApi {
    api;
    constructor(api) {
        this.api = api;
    }
    getTariffByUUID(uuid) {
        const url = TariffApiRoutes.GetTariff;
        const endpoint = url.replace(":uuid", `${uuid}`);
        return this.api.get(endpoint);
    }
}
